<template>
  <WebLayout
    title="Funcionalidades"
    description="Descubre todas las herramientas que Realgestión tiene para ti. Desde control de inventario hasta inteligencia artificial."
    url="https://realgestion.lat/features"
  >
    <Head title="Funcionalidades - Realgestión" />
    
    <div class="bg-white py-12">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="lg:text-center">
          <h2 class="text-base text-orange-600 font-semibold tracking-wide uppercase">Funcionalidades</h2>
          <p class="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Detalle de Funcionalidades
          </p>
          <p class="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
            Explora a fondo todo lo que puedes hacer con Realgestión.
          </p>
        </div>

        <div class="mt-10">
          <div class="space-y-16">
            <div v-for="(feature, index) in features" :key="index" class="relative">
              <div class="flex items-center">
                <div class="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                  <i :class="feature.icon + ' text-xl'" />
                </div>
                <h3 class="ml-4 text-2xl font-bold text-gray-900">{{ feature.title }}</h3>
              </div>
              <p class="mt-2 text-lg text-gray-500">
                {{ feature.description }}
              </p>
              <ul class="mt-4 list-disc list-inside text-base text-gray-500 space-y-2 pl-4">
                <li v-for="(item, itemIndex) in feature.items" :key="itemIndex">
                  <span v-html="renderMarkdown(item)" />
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div class="mt-12 text-center">
          <Link href="/" class="text-orange-600 font-medium hover:text-orange-500">
            &larr; Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  </WebLayout>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue3'
import WebLayout from '@/Layouts/WebLayout.vue'

export default {
  components: {
    Link,
    Head,
    WebLayout,
  },
  props: {
    features: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    renderMarkdown(text) {
      if (!text) return ''
      return text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    },
  },
}
</script>
